


















































































import { UseModal } from "@/components/root/modal";
import Spinner from "@/components/Spinner.vue";
import FolderPath from "@/components/transfer/FolderPath.vue";
import Vue from "vue";
import AddAdditionalFoldersModalVue from "./AddAdditionalFoldersModal.vue";
export default Vue.extend({
  props: ["status", "label_id", "label_name"],
  components: { FolderPath, Spinner },
  setup(props, { emit }) {
    const add_more_folders = async () => {
      const res = await UseModal().show(AddAdditionalFoldersModalVue, {
        label_id: props.label_id,
        label_name: props.label_name,
        // @ts-ignore
        folders: props.status.folders,
      });
      if (res.type == "success") {
        emit("reload");
      }
    };

    return { add_more_folders };
  },
});
